module.exports = __webpack_public_path__ + "img/pattern.8c90e68.png";